var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResizeIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 22,
    viewBox: "0 0 73 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_48_7359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.0815e-06C3 8.0815e-06 66.6502 -1.01019e-05 70 8.0815e-06C69.9411 0.117308 69.8856 0.241487 69.8334 0.372042C66.7739 8.02682 62.4912 16 54.2476 16H18.6961C10.4716 16 6.27144 8.05155 3.1969 0.423339C3.13604 0.272334 3.07049 0.130924 3 8.0815e-06Z",
    fill: "#103045"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.351 2.87453L31.2271 9.99917C31.1611 10.1132 31.1263 10.2425 31.1262 10.3743C31.1261 10.506 31.1607 10.6354 31.2265 10.7495C31.2923 10.8636 31.387 10.9584 31.501 11.0243C31.6151 11.0902 31.7445 11.1249 31.8762 11.1249L40.124 11.1249C40.2557 11.1249 40.3851 11.0902 40.4992 11.0243C40.6132 10.9584 40.7079 10.8636 40.7737 10.7495C40.8395 10.6354 40.8741 10.506 40.874 10.3743C40.8739 10.2425 40.8391 10.1132 40.7731 9.99917L36.6492 2.87453C36.5833 2.76071 36.4887 2.66621 36.3748 2.60052C36.2608 2.53483 36.1316 2.50024 36.0001 2.50024C35.8686 2.50024 35.7394 2.53483 35.6255 2.60052C35.5115 2.66621 35.4169 2.76071 35.351 2.87453Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_48_7359",
    x: 0.333336,
    y: 0,
    width: 72.3333,
    height: 21.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66666
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_48_7359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_48_7359",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIconUp);
export default __webpack_public_path__ + "static/media/resizeIconUp.982d7858076ae059788cc61d7f0421ea.svg";
export { ForwardRef as ReactComponent };